import { OpportunityData } from './types';

export const opportunitiesData: OpportunityData[] = [
  {
    OpportunityID: 101,
    Name: "Pre-Application Virtual Assistant",
    SpeedUpPermitting: 5,
    IncreaseStaffProductivity: 5,
    SimplifyApplicationExperience: 5,
    EnhanceEquitableAccessToServices: 3,
    StrengthenInternalVisibilityDecisionMaking: 2,
    IncreaseProcessTransparency: 4,
    BoostFinancialSustainability: 4,
    CostAndEffort: 3,
    Risk: 2,
    Complexity: 4
  },
  {
    OpportunityID: 102,
    Name: "Pre-Application Eligibility Checker",
    SpeedUpPermitting: 4,
    IncreaseStaffProductivity: 4,
    SimplifyApplicationExperience: 5,
    EnhanceEquitableAccessToServices: 4,
    StrengthenInternalVisibilityDecisionMaking: 3,
    IncreaseProcessTransparency: 3,
    BoostFinancialSustainability: 2,
    CostAndEffort: 3,
    Risk: 3,
    Complexity: 3
  },
  {
    OpportunityID: 103,
    Name: "Intelligent Application Assistant",
    SpeedUpPermitting: 3,
    IncreaseStaffProductivity: 4,
    SimplifyApplicationExperience: 4,
    EnhanceEquitableAccessToServices: 4,
    StrengthenInternalVisibilityDecisionMaking: 3,
    IncreaseProcessTransparency: 3,
    BoostFinancialSustainability: 3,
    CostAndEffort: 3,
    Risk: 2,
    Complexity: 3
  },
  {
    OpportunityID: 104,
    Name: "Fee Estimation & Payment Advisor",
    SpeedUpPermitting: 2,
    IncreaseStaffProductivity: 3,
    SimplifyApplicationExperience: 4,
    EnhanceEquitableAccessToServices: 1,
    StrengthenInternalVisibilityDecisionMaking: 3,
    IncreaseProcessTransparency: 2,
    BoostFinancialSustainability: 4,
    CostAndEffort: 2,
    Risk: 1,
    Complexity: 2
  },
  {
    OpportunityID: 105,
    Name: "Automated Intake Validation",
    SpeedUpPermitting: 4,
    IncreaseStaffProductivity: 2,
    SimplifyApplicationExperience: 5,
    EnhanceEquitableAccessToServices: 4,
    StrengthenInternalVisibilityDecisionMaking: 2,
    IncreaseProcessTransparency: 2,
    BoostFinancialSustainability: 2,
    CostAndEffort: 3,
    Risk: 1,
    Complexity: 2
  },
  {
    OpportunityID: 107,
    Name: "Automated Plan Review",
    SpeedUpPermitting: 5,
    IncreaseStaffProductivity: 5,
    SimplifyApplicationExperience: 3,
    EnhanceEquitableAccessToServices: 2,
    StrengthenInternalVisibilityDecisionMaking: 3,
    IncreaseProcessTransparency: 2,
    BoostFinancialSustainability: 5,
    CostAndEffort: 4,
    Risk: 3,
    Complexity: 5
  },
  {
    OpportunityID: 108,
    Name: "Intelligent Multi-department Review Routing",
    SpeedUpPermitting: 4,
    IncreaseStaffProductivity: 3,
    SimplifyApplicationExperience: 3,
    EnhanceEquitableAccessToServices: 2,
    StrengthenInternalVisibilityDecisionMaking: 4,
    IncreaseProcessTransparency: 3,
    BoostFinancialSustainability: 3,
    CostAndEffort: 3,
    Risk: 3,
    Complexity: 4
  },
  {
    OpportunityID: 109,
    Name: "AI-Assisted Revision Tracking",
    SpeedUpPermitting: 3,
    IncreaseStaffProductivity: 4,
    SimplifyApplicationExperience: 5,
    EnhanceEquitableAccessToServices: 1,
    StrengthenInternalVisibilityDecisionMaking: 3,
    IncreaseProcessTransparency: 2,
    BoostFinancialSustainability: 3,
    CostAndEffort: 2,
    Risk: 2,
    Complexity: 3
  },
  {
    OpportunityID: 110,
    Name: "Smart Reviewer Assignment",
    SpeedUpPermitting: 2,
    IncreaseStaffProductivity: 4,
    SimplifyApplicationExperience: 2,
    EnhanceEquitableAccessToServices: 2,
    StrengthenInternalVisibilityDecisionMaking: 3,
    IncreaseProcessTransparency: 3,
    BoostFinancialSustainability: 3,
    CostAndEffort: 2,
    Risk: 2,
    Complexity: 3
  },
  {
    OpportunityID: 111,
    Name: "Inspection Scheduling Optimizer",
    SpeedUpPermitting: 4,
    IncreaseStaffProductivity: 3,
    SimplifyApplicationExperience: 4,
    EnhanceEquitableAccessToServices: 1,
    StrengthenInternalVisibilityDecisionMaking: 3,
    IncreaseProcessTransparency: 2,
    BoostFinancialSustainability: 3,
    CostAndEffort: 2,
    Risk: 2,
    Complexity: 3
  },
  {
    OpportunityID: 113,
    Name: "Digital QA/QC for Final Inspections",
    SpeedUpPermitting: 3,
    IncreaseStaffProductivity: 3,
    SimplifyApplicationExperience: 3,
    EnhanceEquitableAccessToServices: 2,
    StrengthenInternalVisibilityDecisionMaking: 3,
    IncreaseProcessTransparency: 3,
    BoostFinancialSustainability: 3,
    CostAndEffort: 3,
    Risk: 2,
    Complexity: 2
  },
  {
    OpportunityID: 114,
    Name: "Post-Occupancy Analytics",
    SpeedUpPermitting: 2,
    IncreaseStaffProductivity: 2,
    SimplifyApplicationExperience: 3,
    EnhanceEquitableAccessToServices: 2,
    StrengthenInternalVisibilityDecisionMaking: 5,
    IncreaseProcessTransparency: 4,
    BoostFinancialSustainability: 3,
    CostAndEffort: 4,
    Risk: 2,
    Complexity: 3
  },
  {
    OpportunityID: 115,
    Name: "Real-Time Performance Dashboard",
    SpeedUpPermitting: 2,
    IncreaseStaffProductivity: 3,
    SimplifyApplicationExperience: 1,
    EnhanceEquitableAccessToServices: 2,
    StrengthenInternalVisibilityDecisionMaking: 5,
    IncreaseProcessTransparency: 4,
    BoostFinancialSustainability: 3,
    CostAndEffort: 3,
    Risk: 2,
    Complexity: 3
  },
  {
    OpportunityID: 116,
    Name: "Regulatory Update Analyzer",
    SpeedUpPermitting: 2,
    IncreaseStaffProductivity: 3,
    SimplifyApplicationExperience: 2,
    EnhanceEquitableAccessToServices: 2,
    StrengthenInternalVisibilityDecisionMaking: 5,
    IncreaseProcessTransparency: 3,
    BoostFinancialSustainability: 2,
    CostAndEffort: 2,
    Risk: 2,
    Complexity: 3
  },
  {
    OpportunityID: 117,
    Name: "Cross-Agency Collaboration Hub for Managing Revisions",
    SpeedUpPermitting: 4,
    IncreaseStaffProductivity: 3,
    SimplifyApplicationExperience: 3,
    EnhanceEquitableAccessToServices: 2,
    StrengthenInternalVisibilityDecisionMaking: 4,
    IncreaseProcessTransparency: 3,
    BoostFinancialSustainability: 3,
    CostAndEffort: 3,
    Risk: 2,
    Complexity: 5
  },
  {
    OpportunityID: 119,
    Name: "Risk-Based Smart Prioritization of Applications",
    SpeedUpPermitting: 5,
    IncreaseStaffProductivity: 4,
    SimplifyApplicationExperience: 3,
    EnhanceEquitableAccessToServices: 2,
    StrengthenInternalVisibilityDecisionMaking: 4,
    IncreaseProcessTransparency: 3,
    BoostFinancialSustainability: 4,
    CostAndEffort: 4,
    Risk: 2,
    Complexity: 3
  },
  {
    OpportunityID: 120,
    Name: "Forecasting Model for Permits & Staffing",
    SpeedUpPermitting: 1,
    IncreaseStaffProductivity: 4,
    SimplifyApplicationExperience: 1,
    EnhanceEquitableAccessToServices: 2,
    StrengthenInternalVisibilityDecisionMaking: 5,
    IncreaseProcessTransparency: 3,
    BoostFinancialSustainability: 4,
    CostAndEffort: 4,
    Risk: 2,
    Complexity: 4
  },
  {
    OpportunityID: 121,
    Name: "Automated Notification & Reminder System",
    SpeedUpPermitting: 4,
    IncreaseStaffProductivity: 2,
    SimplifyApplicationExperience: 5,
    EnhanceEquitableAccessToServices: 3,
    StrengthenInternalVisibilityDecisionMaking: 1,
    IncreaseProcessTransparency: 3,
    BoostFinancialSustainability: 2,
    CostAndEffort: 3,
    Risk: 2,
    Complexity: 4
  },
  {
    OpportunityID: 122,
    Name: "Code Analyzer (Gaps & Ambiguities)",
    SpeedUpPermitting: 1,
    IncreaseStaffProductivity: 3,
    SimplifyApplicationExperience: 2,
    EnhanceEquitableAccessToServices: 1,
    StrengthenInternalVisibilityDecisionMaking: 5,
    IncreaseProcessTransparency: 2,
    BoostFinancialSustainability: 2,
    CostAndEffort: 3,
    Risk: 2,
    Complexity: 4
  },
  {
    OpportunityID: 123,
    Name: "Automated Document & Form Generation",
    SpeedUpPermitting: 3,
    IncreaseStaffProductivity: 4,
    SimplifyApplicationExperience: 1,
    EnhanceEquitableAccessToServices: 1,
    StrengthenInternalVisibilityDecisionMaking: 3,
    IncreaseProcessTransparency: 2,
    BoostFinancialSustainability: 4,
    CostAndEffort: 3,
    Risk: 3,
    Complexity: 3
  },
  {
    OpportunityID: 124,
    Name: "Zoning What-If Scenario Modeling",
    SpeedUpPermitting: 1,
    IncreaseStaffProductivity: 4,
    SimplifyApplicationExperience: 1,
    EnhanceEquitableAccessToServices: 5,
    StrengthenInternalVisibilityDecisionMaking: 2,
    IncreaseProcessTransparency: 4,
    BoostFinancialSustainability: 3,
    CostAndEffort: 4,
    Risk: 2,
    Complexity: 5
  }
];